import { StyleSheet } from '@react-pdf/renderer';
import COLORS from '../../../resources/style/Themes';
export const reportStyles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 40,
    position: 'relative',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  section: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  logo: {
    width: 150,
    height: 'auto',
    padding: 10,
    marginLeft: 10,
    marginTop: 10,
    backgroundColor: COLORS.SAFEGUARD_BLUE,
  },
  generatedBySection: {
    position: 'absolute',
    bottom: 10,
    right: 10,
    textAlign: 'right',
  },
  header: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  subsectionHeader: {
    fontSize: 12,
    fontWeight: 'bold',
    marginTop: 10,
    marginBottom: 10,
  },
  text: {
    fontSize: 10,
    marginBottom: 5,
  },
  boldText: {
    fontSize: 10,
    fontWeight: 'bold',
  },
  emergencyMessageText: {
    fontSize: 10,
    marginBottom: 2,
  },
  footerText: {
    fontSize: 8,
  },
  image: {
    width: 300,
    height: 150,
    marginVertical: 10,
    paddingLeft: 10,
  },
  messagesSection: {
    marginTop: 5,
    paddingRight: 10,
    paddingLeft: 10,
  },
  userLocationGroup: {
    paddingLeft: 10,
    paddingRight: 10,
    marginBottom: 10,
    break: false,
  },
  userNameHeader: {
    fontSize: 10,
  },
  table: {
    display: 'table',
    width: 'auto',
    marginTop: 5,
    break: false,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableColHeader: {
    width: '50%',
    borderStyle: 'solid',
    borderWidth: 1,
    marginRight: -1,
    marginBottom: -1,
    fontSize: 10,
    fontWeight: 'bold',
    padding: 4,
    textAlign: 'center',
  },
  tableCol: {
    width: '50%',
    borderStyle: 'solid',
    borderWidth: 1,
    marginRight: -1,
    marginBottom: -1,
    fontSize: 8,
    padding: 4,
    textAlign: 'center',
  },
});
